class window.PusherInstance
  constructor: ->
    @instance = new Pusher '<%= Rails.application.credentials.dig(:pusher, :key) %>',
      cluster: '<%= Rails.application.credentials.dig(:pusher, :cluster) %>'
      encrypted: true
